import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

const STATUS_COLORS = { new: "#3AB4FF", contacted: "#FFD23F", approved: "#00DC82", dismissed: "#6F7585" };

export default function AdminTrialRequests() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/trial-requests").then((r) => setItems(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/trial-requests/${id}`, { status }); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Update failed"); }
  };

  return (
    <div className="p-6 lg:p-8 max-w-[1200px] mx-auto">
      <div className="kr-overline text-[#8A52FF]">[ TRIAL REQUESTS ]</div>
      <h1 className="font-display text-3xl mt-2 tracking-tight">Trial Requests</h1>
      <p className="text-white/50 text-sm mt-1.5">Users who requested early access while AlphaCore is in trial mode.</p>

      <div className="mt-6 kr-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-white/40 border-b border-white/5">
              <th className="text-left p-3 font-mono text-[10px] tracking-wider uppercase">User</th>
              <th className="text-left p-3 font-mono text-[10px] tracking-wider uppercase">Plan</th>
              <th className="text-left p-3 font-mono text-[10px] tracking-wider uppercase">Requested</th>
              <th className="text-left p-3 font-mono text-[10px] tracking-wider uppercase">Status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.request_id} className="border-b border-white/5" data-testid={`trial-request-${t.request_id}`}>
                <td className="p-3">{t.user_email}</td>
                <td className="p-3 capitalize">{t.requested_plan}</td>
                <td className="p-3 text-xs text-white/50">{new Date(t.created_at).toLocaleString()}</td>
                <td className="p-3">
                  <Select value={t.status || "new"} onValueChange={(v) => setStatus(t.request_id, v)}>
                    <SelectTrigger className="bg-[#07080B] border-white/10 h-8 w-36 text-xs" data-testid={`trial-status-${t.request_id}`}>
                      <span className="flex items-center gap-2">
                        <span className="w-2 h-2 rounded-full" style={{ background: STATUS_COLORS[t.status || "new"] }} />
                        <SelectValue />
                      </span>
                    </SelectTrigger>
                    <SelectContent className="bg-[#101219] border-white/10">
                      {["new", "contacted", "approved", "dismissed"].map((s) => <SelectItem key={s} value={s} className="focus:bg-white/5 capitalize">{s}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={4} className="p-10 text-center text-white/40"><Sparkles className="h-5 w-5 mx-auto mb-2 text-white/25" />No trial requests yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
